import { Reducer } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { CITIES_REQUEST, CITIES_SUCCESSFUL, CITIES_FAILURE } from 'action-creators/cities';
import { RESET } from 'action-creators/generic';
import { City } from 'models/city';

export interface CitiesState {
  isLoading: boolean;
  bySearch: City[];
  error: string | null;
}

const initialState: CitiesState = {
  isLoading: false,
  bySearch: [],
  error: null,
};

const reducer: Reducer<CitiesState> = (state = initialState, action) => {
  switch (action.type) {
    case CITIES_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case CITIES_SUCCESSFUL:
      return {
        ...state,
        bySearch: action.payload,
        isLoading: false,
      };
    case CITIES_FAILURE:
      return {
        ...state,
        error: action.payload,
        bySearch: [],
        isLoading: false,
      };
    case RESET:
      return initialState;
    default:
      return state;
  }
};

const persistConfig = {
  storage,
  version: 1,
  key: 'cities',
  blacklist: ['isLoading', 'error'],
};

export default persistReducer(persistConfig, reducer);
